<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 5.60039C0.5 5.60039 0.1 5.30039 0 4.80039C0 4.30039 0.2 3.90039 0.7 3.70039L7.7 1.10039C7.9 1.00039 8.1 1.00039 8.4 1.10039L15.4 3.70039C15.9 3.90039 16.1 4.30039 16 4.80039C15.8 5.30039 15.4 5.60039 15 5.60039V13.0005C15.6 13.0005 16 13.4005 16 14.0005C16 14.6005 15.6 15.0005 15 15.0005H14.0135C14.009 15.0006 14.0045 15.0006 14 15.0006C13.9946 15.0006 13.9892 15.0006 13.9838 15.0005H10.0135L10 15.0006L9.98383 15.0005H6.01617L6 15.0006L5.98383 15.0005H2.01617L2 15.0006L1.98383 15.0005H1C0.4 15.0005 0 14.6005 0 14.0005C0 13.4005 0.4 13.0005 1 13.0005V5.60039ZM13 13.0005V5.60039H11V13.0005H13ZM7 5.60039H9V13.0005H7V5.60039ZM5 13.0005V5.60039H3V13.0005H5Z"
    />
  </svg>
</template>
